import { useState, useEffect } from 'react';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Typography,
  useTheme,
} from '@mui/material';

import { Delete } from '@mui/icons-material';

import api from '../../services/api';
import toastError from '../../toasts/toastError';
import { getStyled } from './styles';

const MessageReactionsModal = ({ open, onClose, message, user }) => {
  const theme = useTheme();
  const classes = getStyled(theme);

  const [reactions, setReactions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadReactions = async () => {
      setLoading(true);
      try {
        const response = await api.get(`/messages/${message.id}/reactions`);
        setReactions(response.data);
      } catch (err) {
        toastError(err);
      } finally {
        setLoading(false);
      }
    };

    if (open && message) {
      loadReactions();
    }
  }, [open, message]);

  const handleDeleteReaction = async (reaction) => {
    try {
      await api.delete(`/messages/${message.id}/reactions/${reaction.body}`, {
        data: { fromMe: reaction.fromMe },
      });

      setReactions((prev) => prev.filter((r) => r.id !== reaction.id));

      if (reactions.length === 1) {
        onClose();
      }
    } catch (err) {
      toastError(err);
    }
  };

  const groupReactionsByEmoji = () => {
    const grouped = {};
    reactions.forEach((reaction) => {
      if (!grouped[reaction.body]) {
        grouped[reaction.body] = [];
      }
      grouped[reaction.body].push(reaction);
    });
    return grouped;
  };

  const groupedReactions = groupReactionsByEmoji();

  return (
    <Dialog open={open} onClose={onClose} style={classes.dialog} maxWidth='sm'>
      <DialogTitle disableTypography style={classes.dialogTitle}>
        <Typography variant='h6'>Reações</Typography>
      </DialogTitle>

      <DialogContent style={classes.content} dividers>
        {loading ? (
          <Typography align='center'>Carregando...</Typography>
        ) : (
          Object.entries(groupedReactions).map(([emoji, reactionsList]) => (
            <div key={emoji}>
              <Typography
                variant='subtitle2'
                style={{ margin: '12px 0 4px 8px' }}
              ></Typography>
              <List disablePadding>
                {reactionsList.map((reaction) => (
                  <ListItem
                    key={reaction.id}
                    style={classes.listItem}
                    disableGutters
                  >
                    <ListItemText
                      primary={
                        <span style={classes.contactName}>
                          {reaction.contact?.name || user.name}
                          {reaction.fromMe && (
                            <span style={classes.fromMeTag}>Você</span>
                          )}
                        </span>
                      }
                    />
                    <span style={classes.reactionEmoji}>{reaction.body}</span>
                    {console.log(reaction.fromMe)}
                    {reaction.fromMe == true ? (
                      <IconButton
                        size='small'
                        style={classes.deleteButton}
                        onClick={() => handleDeleteReaction(reaction)}
                      >
                        <Delete
                          fontSize='small'
                          sx={{ color: theme.custom.colors.cancelButton }}
                        />
                      </IconButton>
                    ) : (
                      <IconButton
                        size='small'
                        style={{
                          padding: 4,
                          display: 'hidden !important',
                          opacity: 0,
                          cursor: 'default',
                        }}
                      >
                        <Delete
                          fontSize='small'
                          sx={{
                            color: theme.custom.colors.cancelButton,
                            displa: 'hidden ! important',
                          }}
                        />
                      </IconButton>
                    )}
                  </ListItem>
                ))}
              </List>
            </div>
          ))
        )}

        {!loading && reactions.length === 0 && (
          <Typography align='center' color='textSecondary'>
            Nenhuma reação
          </Typography>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default MessageReactionsModal;
